import { render } from "./ProfileLayoutClean.vue?vue&type=template&id=87717674&scoped=true"
import script from "./ProfileLayoutClean.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutClean.vue?vue&type=script&lang=js"

import "./ProfileLayoutClean.vue?vue&type=style&index=0&id=87717674&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87717674"]])

export default __exports__